import React, { JSX } from "react";
import { Container } from "./Title.styled";
import { colors } from "../../../../styles/theme";
import { useResponsiveScaler } from "../../../../lib/ResponsiveScaler";

export type TitleProps = {} & React.ComponentProps<typeof Container>;

export const Title: React.FC<TitleProps> = (props): JSX.Element => {
  const { ...rest } = props;
  const { rpx } = useResponsiveScaler();
  return (
    <Container {...rest} variant={'v6'} sx={{
      color: colors.text.v4,
      ...rpx({
        marginBottom: '50px',
      }, { mobile: {
       marginBottom: '10px',
      }})
    }}/>
  );
};
